import { JSX } from 'react';
import styled from 'styled-components';
import AccordionItem from './AccordionItem/index.tsx';
import toRem from 'utils/toRem';

export interface AccordionItemProps {
  className?: string;
  id: number;
  title: string;
  activeTitle?: string;
  content: string;
  index?: number;
  numbered?: boolean;
}

export interface AccordionProps {
  accordionItems: Array<AccordionItemProps>;
  className?: string;
  numbered?: boolean;
  iconClosed?: JSX.Element;
  iconOpen?: JSX.Element;
}

const StyledAccordion = styled.ul`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  min-height: ${toRem(40)};
  border: 0;
`;

const Accordion = ({
  className,
  accordionItems,
  numbered = false,
  iconClosed,
  iconOpen,
}: AccordionProps) => (
  <StyledAccordion className={className}>
    {accordionItems.map(
      ({ id, title, activeTitle, content }: AccordionItemProps, index) => (
        <AccordionItem
          iconClosed={iconClosed}
          iconOpen={iconOpen}
          className="accordion__item"
          key={id}
          index={index}
          title={title}
          activeTitle={activeTitle}
          content={content}
          numbered={numbered}
          id={id}
        />
      ),
    )}
  </StyledAccordion>
);

export default Accordion;
